import { Answer, AnswerType, Page, Question, QuestionType } from "@types-runway/questionnaire";
import { QuestionOverrideDTO } from "@utils/questionnaire/QuestionOverrideDTO";

export const inferQuestionType = (content: Answer["content"]): QuestionType => {
  if (
    typeof content === "string" &&
    ["true", "false"].includes(content.toLocaleLowerCase())
  ) {
    return "boolean";
  }

  if (typeof content === "string") {
    return "string";
  }

  return "number";
};

export const composeQuestion = (page: Page, answer: Answer): Question => {
  return {
    question: page.question ?? "N/A",
    answer:
      typeof answer.content === "object"
        ? JSON.stringify(answer.content)
        : answer.content.toString(),
    type: inferQuestionType(answer.content),
    important: answer.important ?? false,
  };
};

export interface OverrideResult {
  stateKey: string;
  question: Question;
}

export const composeOverrideQuestions = (
  page: Page,
  answer: Answer
): OverrideResult[] => {
  if (!page.actorOverrides || page.actorOverrides.overrides.length === 0) {
    return [];
  }

  const results: OverrideResult[] = [];
  const overrides = page.actorOverrides.overrides;
  const nestingProperty = page.storageMappings?.nestingProperty as
    | keyof AnswerType
    | undefined;

  overrides.forEach((override) => {
    const overrideAnswer =
      nestingProperty && answer.content[nestingProperty]
        ? answer.content[nestingProperty][override.dataPoint as keyof AnswerType]
        : answer.content[override.dataPoint as keyof AnswerType];

    if (overrideAnswer) {
      const stateKey = `${page.actorOverrides?.payload}${override.dataPoint}`;
      results.push({
        stateKey,
        question: new QuestionOverrideDTO(override, overrideAnswer),
      });
    }
  });

  return results;
};
